<template>

    <v-modal
        :open="open"
        class="c-edit_issue_modal">
        <h2 class="c-edit_issue_modal__title">Edycja nazwy problemu</h2>
        <form @submit.prevent="ok" data-vv-scope="edit_issue-form">
            <form-input
                v-model="issue.name"
                label="Nazwa problemu"
                v-validate="'required'"
                data-vv-as="problem"
                speech-to-text>
            </form-input>
            <form-row align="between">
                <v-btn
                    type="green"
                    role="submit"
                    has-loader
                    :loading="isLoading">
                    Zapisz
                </v-btn>
                <v-btn
                    type="white"
                    @click="cancel">
                    Anuluj
                </v-btn>
            </form-row>
        </form>
    </v-modal>

</template>


<script>

import {mapGetters} from 'vuex'
import VModal from 'Components/VModal'
import {FormRow, FormInput} from 'Components/Form'
import VBtn from 'Components/VBtn'

export default {

    name: 'IssueEditModal',

    data() {
        return {
            issue: {},
            open: false,
            isLoading: false
        }
    },

    methods: {
        cancel() {
            this.open = false
            this.$emit('cancel', this.issue)
        },

        ok() {
            this.$validator.validateAll('edit_issue-form').then((isValid) => {
                if (isValid) {
                    this.isLoading = true
                    this.$emit('ok', this.issue, this.closeModal)
                }
            })
        },
        closeModal() {
            this.isLoading = false
            this.open = false
        }
    },

    mounted() {
        this.$on('open', (issue) => {
            this.open = true
            this.issue = JSON.parse(JSON.stringify(issue))
        })
    },

    beforeDestroy() {
        this.$off('open')
    },

    components: {
        FormRow,
        FormInput,
        VModal,
        VBtn
    }

}

</script>


<style lang="scss">

@import '~Style/_utils.scss';

.c-edit_issue_modal {
    &__title {
        margin-bottom: 2rem;
    }
}

</style>
